import React, { useEffect } from 'react';

import { useTranslation } from 'react-i18next';

import LanguageIcon from '@material-ui/icons/Language';
import { blue } from '@material-ui/core/colors';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';

import {
  Avatar,
  Divider,
  ListItemAvatar,
  ListItemText,
  ListSubheader,
  makeStyles
} from '@material-ui/core';

const useStyles = makeStyles(() => ({
  langFlag: {
    marginLeft: '0.3rem',
    height: '1.7rem',
    position: 'relative',
    bottom: '0.1rem'
  },
  langSeparator: {
    marginLeft: '1.5rem',
    marginRight: '1.5rem'
  },
  langIcon: {
    backgroundColor: blue[100],
    color: blue[600]
  },
  subheader: {
    marginTop: '1rem'
  }
}));

export default function PdfLanguageSelector({
  setOpenPdfPreview,
  openPdfPreview,
  contentLanguage,
  pdfURL,
  langSets
}) {
  const { t } = useTranslation();
  const classes = useStyles();

  const noLangSets = !langSets || langSets.length == 0;

  useEffect(() => {
    if (noLangSets && openPdfPreview) {
      startPdfPreview(null);
    }
  }, [openPdfPreview]);

  function startPdfPreview(contentLanguageSet) {
    setOpenPdfPreview(false);

    if (!contentLanguage) {
      const currentUrl = new URL(window.location.href);
      const currentParams = new URLSearchParams(currentUrl.search);
      contentLanguage = currentParams.get('contentLanguage');
    }

    let url = pdfURL;
    const pdfParams = new URLSearchParams(pdfURL);
    if (!pdfParams.get('contentLanguage') && contentLanguage) {
      url += '&contentLanguage=' + contentLanguage;
    }

    if (contentLanguageSet) {
      url +=
        '&contentLanguageSet=' +
        contentLanguageSet.map((item) => item.value).join(',');
    }
    window.open(url);
  }

  const selectLanguageSet = (contentLanguageSet) => {
    startPdfPreview(contentLanguageSet);
  };

  if (noLangSets) {
    return null;
  }

  const handleClose = () => {
    setOpenPdfPreview(false);
  };

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={openPdfPreview}
    >
      <DialogTitle id="simple-dialog-title">
        {t('data.pdfPreviewLang')}
      </DialogTitle>
      <List>
        <ListItem button onClick={() => selectLanguageSet(null)}>
          <ListItemAvatar>
            <Avatar className={classes.langIcon}>
              <LanguageIcon />
            </Avatar>
          </ListItemAvatar>
          <ListItemText primary={t('data.nolanguageSets')} />
        </ListItem>
        <Divider />
        <ListSubheader className={classes.subheader}>
          {t('data.languageSets')}:
        </ListSubheader>
        {langSets &&
          langSets.map((langSet) => (
            <ListItem
              button
              onClick={() => selectLanguageSet(langSet)}
              key={langSet.map((item) => item.value).join('|')}
            >
              <ListItemAvatar>
                <Avatar className={classes.langIcon}>
                  <LanguageIcon />
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={
                  <>
                    {langSet.length > 0 &&
                      langSet.map((lang, index) => (
                        <span key={lang.value}>
                          <span>{lang.label + ' (' + lang.value}</span>
                          <img
                            className={classes.langFlag}
                            src={lang.customContentImage}
                          ></img>
                          <span>{' )'}</span>
                          {index < langSet.length - 1 && (
                            <span className={classes.langSeparator}>+</span>
                          )}
                        </span>
                      ))}
                  </>
                }
              />
              <Divider />
            </ListItem>
          ))}
      </List>
    </Dialog>
  );
}
